import { useMutation, useQueryClient } from 'libs/query'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { useTranslation } from 'libs/i18n'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import type { TypeItem } from 'features/types/types/types.types'

type UseCreateTypeMutationProps = {
	onSuccess: () => void
}

export const useCreateTypeMutation = ({ onSuccess }: UseCreateTypeMutationProps) => {
	const { t } = useTranslation()

	const queryClient = useQueryClient()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: createType, isPending: createTypeLoading } = useMutation({
		mutationFn: (data: Pick<TypeItem, 'name'>) => {
			return axiosPrivate.post(apiRoutes.types(''), data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.types.all })
			useToast({ type: 'success', message: t('New type created!') })()

			onSuccess()
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		createType,
		createTypeLoading
	}
}
